import { useEffect, useState } from 'react';
import { HttpService } from 'app/services';

const useEditableField = (name) => {
  const [editableField, setEditableField] = useState([]);

  useEffect(() => {
    HttpService.post('/api/setting/name', { name }).then((response) => {
      if (response.isSuccess) {
        setEditableField(response.data);
      }
    });
  }, []);

  return { editableField };
};

export default useEditableField;
